(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  const initCartQuantityControls = (container = document) => {
    container.querySelectorAll('[data-cart-section]').forEach((section) => {
      if (section.dataset.cartQuantityInitialized === 'true') return;
      section.dataset.cartQuantityInitialized = 'true';

      section.addEventListener('click', (event) => {
        const minusBtn = event.target.closest('.cart-section__quantity-btn--minus');
        const plusBtn = event.target.closest('.cart-section__quantity-btn--plus');
        if (!minusBtn && !plusBtn) return;

        const selector = event.target.closest('.cart-section__quantity-selector');
        const input = selector?.querySelector('.cart-section__quantity-input');
        if (!input) return;

        const min = parseInt(input.min, 10) || 0;
        const value = parseInt(input.value, 10) || 0;

        if (minusBtn && value > min) {
          input.value = value - 1;
        } else if (plusBtn) {
          input.value = value + 1;
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initCartQuantityControls());

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => initCartQuantityControls(event.target));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
  class CollectionCarousel {
    constructor(section) {
      this.section = section;
      this.slider = section.querySelector('[data-carousel-slider]');
      this.prevButton = section.querySelector('.carousel-nav-button--prev');
      this.nextButton = section.querySelector('.carousel-nav-button--next');
      this.dotsContainer = section.querySelector('[data-carousel-dots]');
      this.items = section.querySelectorAll('.collection-carousel-item');
      
      if (!this.slider) return;
      
      this.init();
    }
    
    init() {
      this.createDots();
      this.updateButtons();
      this.checkOverflow();
      this.attachEvents();
    }
    
    checkOverflow() {
      if (!this.slider) return;
      
      // Check if content width exceeds container width
      const hasOverflow = this.slider.scrollWidth > this.slider.clientWidth;
      
      if (hasOverflow) {
        this.slider.classList.add('has-overflow');
      } else {
        this.slider.classList.remove('has-overflow');
      }
    }
    
    getVisibleItemsCount() {
      if (this.items.length === 0) return 1;
      
      const itemWidth = this.items[0].offsetWidth;
      const gap = parseInt(getComputedStyle(this.slider).gap) || 0;
      const containerWidth = this.slider.clientWidth;
      
      // Calculate how many full items can fit
      const visibleCount = Math.floor(containerWidth / (itemWidth + gap));
      return Math.max(1, visibleCount);
    }
    
    getTotalPages() {
      const visibleCount = this.getVisibleItemsCount();
      const totalPages = Math.ceil(this.items.length / visibleCount);
      return Math.max(1, totalPages);
    }
    
    getCurrentPage() {
      if (this.items.length === 0) return 0;
      
      const scrollLeft = this.slider.scrollLeft;
      const scrollWidth = this.slider.scrollWidth;
      const clientWidth = this.slider.clientWidth;
      const totalPages = this.getTotalPages();
      
      // Check if we're at the end of the scroll
      const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;
      if (isAtEnd) {
        return totalPages - 1;
      }
      
      const itemWidth = this.items[0].offsetWidth;
      const gap = parseInt(getComputedStyle(this.slider).gap) || 0;
      const visibleCount = this.getVisibleItemsCount();
      
      // Calculate which page we're on
      const itemsScrolled = Math.round(scrollLeft / (itemWidth + gap));
      const currentPage = Math.floor(itemsScrolled / visibleCount);
      
      return Math.min(currentPage, this.getTotalPages() - 1);
    }
    
    createDots() {
      if (!this.dotsContainer || this.items.length === 0) return;
      
      const totalPages = this.getTotalPages();
      const hasOverflow = this.slider.scrollWidth > this.slider.clientWidth;
      
      // Only show dots if there's more than one page and content overflows
      if (totalPages <= 1 || !hasOverflow) {
        this.dotsContainer.style.display = 'none';
        return;
      }
      
      this.dotsContainer.style.display = 'flex';
      this.dotsContainer.innerHTML = '';
      
      for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('button');
        dot.classList.add('carousel-dot');
        dot.setAttribute('aria-label', `Go to page ${i + 1}`);
        if (i === 0) dot.classList.add('active');
        
        dot.addEventListener('click', () => {
          this.scrollToPage(i);
        });
        
        this.dotsContainer.appendChild(dot);
      }
    }
    
    scrollToPage(pageIndex) {
      const visibleCount = this.getVisibleItemsCount();
      const targetItemIndex = pageIndex * visibleCount;
      const item = this.items[targetItemIndex];
      
      if (item) {
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }
    
    updateButtons() {
      if (!this.slider) return;
      
      const hasOverflow = this.slider.scrollWidth > this.slider.clientWidth;
      const isAtStart = this.slider.scrollLeft <= 0;
      const isAtEnd = this.slider.scrollLeft + this.slider.clientWidth >= this.slider.scrollWidth - 1;
      
      // Hide buttons if no overflow
      if (this.prevButton) {
        if (!hasOverflow) {
          this.prevButton.style.display = 'none';
        } else {
          this.prevButton.style.display = 'flex';
          this.prevButton.disabled = isAtStart;
        }
      }
      
      if (this.nextButton) {
        if (!hasOverflow) {
          this.nextButton.style.display = 'none';
        } else {
          this.nextButton.style.display = 'flex';
          this.nextButton.disabled = isAtEnd;
        }
      }
      
      this.updateActiveDot();
    }
    
    updateActiveDot() {
      if (!this.dotsContainer) return;
      
      const dots = this.dotsContainer.querySelectorAll('.carousel-dot');
      const currentPage = this.getCurrentPage();
      const totalPages = this.getTotalPages();
      
      // Calculate scroll progress within current page for smooth transitions
      const visibleCount = this.getVisibleItemsCount();
      const itemWidth = this.items[0]?.offsetWidth || 0;
      const gap = parseInt(getComputedStyle(this.slider).gap) || 0;
      const scrollLeft = this.slider.scrollLeft;
      const pageWidth = visibleCount * (itemWidth + gap);
      const currentPageScrollStart = currentPage * pageWidth;
      const scrollProgress = (scrollLeft - currentPageScrollStart) / pageWidth;
      
      dots.forEach((dot, index) => {
        const isActive = index === currentPage;
        const isNext = index === currentPage + 1;
        
        // Remove active class from all, then add to current
        if (isActive) {
          if (!dot.classList.contains('active')) {
            dot.classList.add('active');
            // Trigger reflow to restart animation
            void dot.offsetWidth;
          }
        } else {
          dot.classList.remove('active');
        }
        
        // Add scale animation to next dot as we approach it
        if (isNext && scrollProgress > 0.5) {
          const nextScale = 1 + (scrollProgress - 0.5) * 0.6;
          dot.style.transform = `scale(${Math.min(nextScale, 1.3)})`;
        } else if (!isActive) {
          dot.style.transform = 'scale(1)';
        }
      });
    }
    
    attachEvents() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.scroll('prev'));
      }
      
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.scroll('next'));
      }
      
      this.slider.addEventListener('scroll', () => {
        this.updateButtons();
      });
      
      // Update on window resize
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          this.checkOverflow();
          this.createDots();
          this.updateButtons();
        }, 150);
      });
    }
    
    scroll(direction) {
      const visibleCount = this.getVisibleItemsCount();
      const itemWidth = this.items[0]?.offsetWidth || 0;
      const gap = parseInt(getComputedStyle(this.slider).gap) || 0;
      
      // Scroll by the number of visible items (one page)
      const scrollAmount = visibleCount * (itemWidth + gap);
      const scrollDistance = direction === 'next' ? scrollAmount : -scrollAmount;
      
      this.slider.scrollBy({
        left: scrollDistance,
        behavior: 'smooth'
      });
    }
  }
  
  // Initialize carousel
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.collection-carousel-section');
    sections.forEach(section => new CollectionCarousel(section));
  });
  
  // Re-initialize on Shopify section load (theme editor)
  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.collection-carousel-section');
      if (section) new CollectionCarousel(section);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq-item__question').forEach((button) => {
    button.addEventListener('click', function () {
      const item = this.closest('.faq-item');
      item.classList.toggle('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["other-collections"] && !Shopify.designMode) return;
  try {
    
  class OtherCollectionsCarousel {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('[data-oc-track]');
      this.prevButton = section.querySelector('[data-oc-prev]');
      this.nextButton = section.querySelector('[data-oc-next]');
      this.dotsContainer = section.querySelector('[data-oc-dots]');
      this.items = section.querySelectorAll('.other-collections__item');

      if (!this.track || this.items.length === 0) return;

      this.init();
    }

    init() {
      this.createDots();
      this.checkOverflow();
      this.updateButtons();
      this.attachEvents();
    }

    checkOverflow() {
      const hasOverflow = this.track.scrollWidth > this.track.clientWidth;
      this.track.classList.toggle('has-overflow', hasOverflow);
    }

    getGap() {
      return parseInt(getComputedStyle(this.track).gap, 10) || 0;
    }

    getItemWidth() {
      return this.items[0]?.offsetWidth || 0;
    }

    getVisibleCount() {
      const itemWidth = this.getItemWidth();
      if (!itemWidth) return 1;

      const gap = this.getGap();
      const visibleCount = Math.floor(this.track.clientWidth / (itemWidth + gap));
      return Math.max(1, visibleCount);
    }

    getTotalPages() {
      return Math.max(1, Math.ceil(this.items.length / this.getVisibleCount()));
    }

    getCurrentPage() {
      const itemWidth = this.getItemWidth();
      const gap = this.getGap();
      const visibleCount = this.getVisibleCount();
      const totalPages = this.getTotalPages();
      const scrollLeft = this.track.scrollLeft;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;

      if (scrollLeft >= maxScroll - 1) {
        return totalPages - 1;
      }

      const itemsScrolled = Math.round(scrollLeft / (itemWidth + gap));
      return Math.min(Math.floor(itemsScrolled / visibleCount), totalPages - 1);
    }

    createDots() {
      if (!this.dotsContainer) return;

      const totalPages = this.getTotalPages();
      const hasOverflow = this.track.scrollWidth > this.track.clientWidth;

      if (totalPages <= 1 || !hasOverflow) {
        this.dotsContainer.hidden = true;
        this.dotsContainer.innerHTML = '';
        return;
      }

      this.dotsContainer.hidden = false;
      this.dotsContainer.innerHTML = '';

      for (let i = 0; i < totalPages; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'other-collections__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', `Go to page ${i + 1}`);
        dot.addEventListener('click', () => this.scrollToPage(i));
        this.dotsContainer.appendChild(dot);
      }
    }

    scrollToPage(pageIndex) {
      const visibleCount = this.getVisibleCount();
      const targetItem = this.items[pageIndex * visibleCount];

      if (targetItem) {
        targetItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }

    updateActiveDot() {
      if (!this.dotsContainer || this.dotsContainer.hidden) return;

      const currentPage = this.getCurrentPage();
      this.dotsContainer.querySelectorAll('.other-collections__dot').forEach((dot, index) => {
        dot.classList.toggle('is-active', index === currentPage);
      });
    }

    updateButtons() {
      const hasOverflow = this.track.scrollWidth > this.track.clientWidth;
      const isAtStart = this.track.scrollLeft <= 0;
      const isAtEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;

      [this.prevButton, this.nextButton].forEach((button) => {
        if (!button) return;
        button.style.display = hasOverflow ? 'flex' : 'none';
      });

      if (this.prevButton) this.prevButton.disabled = !hasOverflow || isAtStart;
      if (this.nextButton) this.nextButton.disabled = !hasOverflow || isAtEnd;

      this.updateActiveDot();
    }

    scroll(direction) {
      const itemWidth = this.getItemWidth();
      const gap = this.getGap();
      const scrollAmount = this.getVisibleCount() * (itemWidth + gap);

      this.track.scrollBy({
        left: direction === 'next' ? scrollAmount : -scrollAmount,
        behavior: 'smooth',
      });
    }

    attachEvents() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.scroll('prev'));
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.scroll('next'));
      }

      this.track.addEventListener('scroll', () => this.updateButtons());

      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          this.checkOverflow();
          this.createDots();
          this.updateButtons();
        }, 150);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.other-collections').forEach((section) => new OtherCollectionsCarousel(section));
  });

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.other-collections');
      if (section) new OtherCollectionsCarousel(section);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-latest-posts"] && !Shopify.designMode) return;
  try {
    
  class OurLatestPostsCarousel {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('[data-olp-track]');
      this.prevButton = section.querySelector('[data-olp-prev]');
      this.nextButton = section.querySelector('[data-olp-next]');
      this.dotsContainer = section.querySelector('[data-olp-dots]');
      this.items = section.querySelectorAll('.our-latest-posts__item');

      if (!this.track || this.items.length === 0) return;

      this.init();
    }

    init() {
      this.createDots();
      this.checkOverflow();
      this.updateButtons();
      this.attachEvents();
    }

    checkOverflow() {
      const hasOverflow = this.track.scrollWidth > this.track.clientWidth;
      this.track.classList.toggle('has-overflow', hasOverflow);
    }

    getGap() {
      return parseInt(getComputedStyle(this.track).gap, 10) || 0;
    }

    getItemWidth() {
      return this.items[0]?.offsetWidth || 0;
    }

    getVisibleCount() {
      const itemWidth = this.getItemWidth();
      if (!itemWidth) return 1;

      const gap = this.getGap();
      const visibleCount = Math.floor(this.track.clientWidth / (itemWidth + gap));
      return Math.max(1, visibleCount);
    }

    getTotalPages() {
      return Math.max(1, Math.ceil(this.items.length / this.getVisibleCount()));
    }

    getCurrentPage() {
      const itemWidth = this.getItemWidth();
      const gap = this.getGap();
      const visibleCount = this.getVisibleCount();
      const totalPages = this.getTotalPages();
      const scrollLeft = this.track.scrollLeft;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;

      if (scrollLeft >= maxScroll - 1) {
        return totalPages - 1;
      }

      const itemsScrolled = Math.round(scrollLeft / (itemWidth + gap));
      return Math.min(Math.floor(itemsScrolled / visibleCount), totalPages - 1);
    }

    createDots() {
      if (!this.dotsContainer) return;

      const totalPages = this.getTotalPages();
      const hasOverflow = this.track.scrollWidth > this.track.clientWidth;

      if (totalPages <= 1 || !hasOverflow) {
        this.dotsContainer.hidden = true;
        this.dotsContainer.innerHTML = '';
        return;
      }

      this.dotsContainer.hidden = false;
      this.dotsContainer.innerHTML = '';

      for (let i = 0; i < totalPages; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'our-latest-posts__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', `Go to page ${i + 1}`);
        dot.addEventListener('click', () => this.scrollToPage(i));
        this.dotsContainer.appendChild(dot);
      }
    }

    scrollToPage(pageIndex) {
      const visibleCount = this.getVisibleCount();
      const targetItem = this.items[pageIndex * visibleCount];

      if (targetItem) {
        targetItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }

    updateActiveDot() {
      if (!this.dotsContainer || this.dotsContainer.hidden) return;

      const currentPage = this.getCurrentPage();
      this.dotsContainer.querySelectorAll('.our-latest-posts__dot').forEach((dot, index) => {
        dot.classList.toggle('is-active', index === currentPage);
      });
    }

    updateButtons() {
      const hasOverflow = this.track.scrollWidth > this.track.clientWidth;
      const isAtStart = this.track.scrollLeft <= 0;
      const isAtEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;

      [this.prevButton, this.nextButton].forEach((button) => {
        if (!button) return;
        button.style.display = hasOverflow ? 'flex' : 'none';
      });

      if (this.prevButton) this.prevButton.disabled = !hasOverflow || isAtStart;
      if (this.nextButton) this.nextButton.disabled = !hasOverflow || isAtEnd;

      this.updateActiveDot();
    }

    scroll(direction) {
      const itemWidth = this.getItemWidth();
      const gap = this.getGap();
      const scrollAmount = this.getVisibleCount() * (itemWidth + gap);

      this.track.scrollBy({
        left: direction === 'next' ? scrollAmount : -scrollAmount,
        behavior: 'smooth',
      });
    }

    attachEvents() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.scroll('prev'));
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.scroll('next'));
      }

      this.track.addEventListener('scroll', () => this.updateButtons());

      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          this.checkOverflow();
          this.createDots();
          this.updateButtons();
        }, 150);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.our-latest-posts').forEach((section) => new OurLatestPostsCarousel(section));
  });

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.our-latest-posts');
      if (section) new OurLatestPostsCarousel(section);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-stores"] && !Shopify.designMode) return;
  try {
    
  class OurStoresCarousel {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('[data-our-stores-track]');
      this.prevButton = section.querySelector('[data-our-stores-prev]');
      this.nextButton = section.querySelector('[data-our-stores-next]');
      this.cards = section.querySelectorAll('.our-stores__card');

      if (!this.track || this.cards.length === 0) return;

      this.init();
    }

    init() {
      this.checkOverflow();
      this.updateButtons();
      this.attachEvents();
    }

    checkOverflow() {
      const hasOverflow = this.track.scrollWidth > this.track.clientWidth;
      this.track.classList.toggle('has-overflow', hasOverflow);
    }

    updateButtons() {
      if (!this.prevButton || !this.nextButton) return;

      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const tolerance = 2;

      this.prevButton.disabled = this.track.scrollLeft <= tolerance;
      this.nextButton.disabled = this.track.scrollLeft >= maxScroll - tolerance;
    }

    attachEvents() {
      this.prevButton?.addEventListener('click', () => this.scroll('prev'));
      this.nextButton?.addEventListener('click', () => this.scroll('next'));
      this.track.addEventListener('scroll', () => this.updateButtons());

      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          this.checkOverflow();
          this.updateButtons();
        }, 150);
      });
    }

    scroll(direction) {
      const card = this.cards[0];
      if (!card) return;

      const gap = parseInt(getComputedStyle(this.track).gap, 10) || 0;
      const scrollAmount = card.offsetWidth + gap;

      this.track.scrollBy({
        left: direction === 'next' ? scrollAmount : -scrollAmount,
        behavior: 'smooth'
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.our-stores').forEach((section) => new OurStoresCarousel(section));
  });

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.our-stores');
      if (section) new OurStoresCarousel(section);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class ShopifySlideshow {
    constructor(section) {
      this.section = section;
      this.slides = Array.from(section.querySelectorAll('[data-slideshow-slide]'));
      this.dots = Array.from(section.querySelectorAll('[data-slideshow-dot]'));
      this.prevButton = section.querySelector('[data-slideshow-prev]');
      this.nextButton = section.querySelector('[data-slideshow-next]');
      this.currentIndex = Math.max(
        0,
        this.slides.findIndex((slide) => slide.classList.contains('is-active'))
      );
      this.autoplay = section.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) || 5000;
      this.timer = null;

      if (this.slides.length < 1) return;

      this.bindEvents();
      this.goTo(this.currentIndex);
      this.startAutoplay();
    }

    bindEvents() {
      this.prevButton?.addEventListener('click', () => this.previous());
      this.nextButton?.addEventListener('click', () => this.next());

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(parseInt(dot.dataset.slideIndex, 10));
          this.restartAutoplay();
        });
      });

      this.section.addEventListener('mouseenter', () => this.stopAutoplay());
      this.section.addEventListener('mouseleave', () => this.startAutoplay());
      this.section.addEventListener('focusin', () => this.stopAutoplay());
      this.section.addEventListener('focusout', () => this.startAutoplay());
    }

    previous() {
      const nextIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
      this.goTo(nextIndex);
      this.restartAutoplay();
    }

    next() {
      const nextIndex = this.currentIndex === this.slides.length - 1 ? 0 : this.currentIndex + 1;
      this.goTo(nextIndex);
      this.restartAutoplay();
    }

    syncSlideVideos(activeIndex) {
      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;

        slide.querySelectorAll('video').forEach((video) => {
          if (isActive) {
            video.play().catch(() => {});
          } else {
            video.pause();
            video.currentTime = 0;
          }
        });
      });
    }

    goTo(index) {
      if (Number.isNaN(index) || !this.slides[index]) return;

      this.currentIndex = index;

      this.slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
      });

      this.dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.syncSlideVideos(index);
    }

    startAutoplay() {
      if (!this.autoplay || this.slides.length < 2 || window.Shopify?.designMode) return;

      this.stopAutoplay();
      this.timer = window.setInterval(() => this.next(), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (!this.timer) return;

      window.clearInterval(this.timer);
      this.timer = null;
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  const initShopifySlideshows = (container = document) => {
    container.querySelectorAll('[data-slideshow-section]').forEach((section) => {
      if (section.dataset.slideshowInitialized === 'true') return;
      section.dataset.slideshowInitialized = 'true';
      new ShopifySlideshow(section);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initShopifySlideshows());

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => initShopifySlideshows(event.target));

    document.addEventListener('shopify:block:select', (event) => {
      const section = event.target.closest('[data-slideshow-section]');
      const slide = event.target.closest('[data-slideshow-slide]');
      if (!section || !slide) return;

      const slides = Array.from(section.querySelectorAll('[data-slideshow-slide]'));
      const dots = Array.from(section.querySelectorAll('[data-slideshow-dot]'));
      const index = slides.indexOf(slide);

      slides.forEach((item, slideIndex) => item.classList.toggle('is-active', slideIndex === index));
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      slides.forEach((item, slideIndex) => {
        const isActive = slideIndex === index;

        item.querySelectorAll('video').forEach((video) => {
          if (isActive) {
            video.play().catch(() => {});
          } else {
            video.pause();
            video.currentTime = 0;
          }
        });
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
